const header = document.querySelector('header.header');

if (header) {
  if (header.nextElementSibling?.classList.contains('bg-gray-light')) {
    header.classList.add('header-gray-light');
  }
}
